/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIconCircle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm2.131 4c.763 0 1.494.309 2.032.857.536.546.837 1.286.837 2.057s-.3 1.511-.837 2.057L12 17.214 7.837 12.97a2.947 2.947 0 0 1 0-4.114 2.838 2.838 0 0 1 4.064 0l.1.1.099-.1a2.85 2.85 0 0 1 1.897-.854z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgIconCircle as IconCircle };
